import { useEffect, useContext, useRef } from 'react';

import { ViewportContext } from '../contexts/viewport';
import { useFilters } from './useFilters';

import {
  MARGIN_RIGHT_SLIDING_CARD,
  WIDTH_SLIDING_CARD
} from '../utils/variables';

export const useSlidingCards = (cards) => {
  const { isMobile } = useContext(ViewportContext);

  const {
    setSelectedElement,
    selectedElement,
    setRank,
    rank,
    isBeginningOfList,
    isEndOfList
  } = useFilters(cards, false);

  const scrollingContainer = useRef();
  const cardWidth = isMobile
    ? scrollingContainer?.current?.offsetWidth + MARGIN_RIGHT_SLIDING_CARD
    : WIDTH_SLIDING_CARD;

  const handleClick = (index) => {
    const pixelToScroll = cardWidth * (index - rank);
    scrollingContainer.current.scrollLeft += pixelToScroll;
    setRank(index);
  };

  const isCardTransparent = (i) =>
    isBeginningOfList()
      ? rank + 2 === i
      : isEndOfList()
      ? rank - 2 === i
      : rank - 1 === i || rank + 1 === i;

  // Adding horizontal scroll event.
  useEffect(() => {
    const handleScroll = (evt) => {
      const scrollWidth = evt.target.scrollLeft;
      setRank(Math.ceil(scrollWidth / cardWidth));
    };

    scrollingContainer.current.addEventListener('scroll', handleScroll, {
      passive: true
    });

    return function cleanup() {
      scrollingContainer?.current?.removeEventListener('scroll', handleScroll);
    };
  });

  // Updating selected card every time rank is changed (either by scrolling or clicking).
  useEffect(() => {
    setSelectedElement(cards[rank]);
  }, [rank]);

  return {
    handleClick,
    selectedElement,
    scrollingContainer,
    rank,
    isBeginningOfList,
    isEndOfList,
    isCardTransparent
  };
};
